var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Title',{attrs:{"title":_vm.$t('throbax.title'),"description":_vm.$t('throbax.description'),"buttons":_vm.$t('throbax.buttons')}}),_c('ArticleStream',{attrs:{"items":_vm.$t('throbax.points')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }